export class addDepartmentModel {
    SchoolId: number;
    // categoryid: string;
    SBAccessRankId:number;
    Description:string;
    Name: string;
    Responsestatus: any;
    Id:number;
    Statusid:number
}




// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/department/addDepartment.model.ts